module.exports = __webpack_public_path__ + "img/salonBanner4.bb4fe991.png";